/**
 * @class ErrorBoundary
 *
 * @description This component handles errors during render
 */
const ErrorBoundary = {
  name: 'ErrorBoundary',
  props: {
    fallBack: {
      type: Object,
      default: () => ({
        functional: true,
        render(h) {
          return h('div', { class: 'error-boundary' }, 'Oops! Something went wrong.')
        },
      }),
    },
    onError: {
      type: Function,
      default: null,
    },
    stopPropagation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: null,
    }
  },
  errorCaptured(err, vm, info = '') {
    this.error = true
    this.$emit('errorCaptured', { err, vm, info })
    if (this.onError) this.onError(err, vm, info)
    if (this.stopPropagation) return false
  },
  render(h) {
    if (!this.$slots.default.length) {
      return null
    }
    return this.error ? h(this.fallBack) : this.$slots.default[0]
  },
}

const errorBoundaryOptions = {
  props: {
    fallBack: {
      render(h) {
        return h('div', { class: 'alert alert-danger alert-dismissable mn' }, [
          h('span', { class: 'glyphicon glyphicon-alert' }),
          h('span', { class: 'ml10' }, this.$i18n.t('please_check_your_permissions_and_rights')),
          h(
            'span',
            {
              class: 'pull-right hand',
              on: {
                click: async function () {
                  await localStorage.clear()
                  window.location.reload()
                },
              },
            },
            this.$i18n.t('refresh_page'),
          ),
        ])
      },
    },
  },
}

export { ErrorBoundary, errorBoundaryOptions }
